(function () {
  "use strict";

  myCtrl.$inject = ['$scope', 'mtypes', '$rootScope', '$http'];
  function myService($location, $window) {
    return {

      openNewWindow: function () {
        $window.open('/Trainer/#/accountInfo');
      },

      redirect : function() {
        $location.url('/accountInfo');
      }
    };
  }

  function myCtrl($scope, mtypes, $rootScope, $http) {

    $rootScope.enableNormalNav = false;

    $scope.msg2 = "";
    $scope.showProps = false;
    $scope.showFaq = true;
    $scope.showBackButton = false; 

    $scope.props = {
      currentPlan : 'N/A',
      seats : 1,
      trainees : 0
    };
    
    $scope.backButton = function() {
      window.close();
    }
    
    switch ($rootScope.mfConfig.accountStatus) {
      case mtypes.accountStatus.cancelled:
      case mtypes.accountStatus.nonPayment:
        $scope.msg = 'Your account has been cancelled.';
        break;
      case mtypes.accountStatus.trialExpired:
        $scope.msg = 'Your trial has expired.';
        break;
      default :
        $scope.showBackButton = true;
        $scope.showFaq = false;
        $scope.msg = 'Thinking about changing plans?';
        $scope.msg2 = 'We\'d love to talk to you about it.'
        var url = '/mm/account/settings';
        $http.get(url).then(function (response) { 
          $scope.props = response.data;
          $scope.showProps = true;
        });
        break;
    }
  }

  angular
    .module('trainerWebApp.controllers')
    .controller('AccountInfoCtrl', myCtrl);

  angular
    .module('trainerWebApp.services')
    .factory('accountInfoService', ['$location', '$window', myService]);

})();
